<template>
  <v-dialog max-width="350px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Dragon Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-2">
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.speed" label="Speed" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.power" label="Power" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.capacity" label="Capacity" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemDragonConfig} from "@/modules/redactor/models/item/dragon/ItemDragonConfig";

export default {
  name: "r-item-dragon-config",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemDragonConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemDragonConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>